module.exports = __webpack_public_path__ + "img/zs_theme.7054316e.jpg";